module.exports = __webpack_public_path__ + "static/img/brand-show.d5527d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand-show.png
// module id = sj8y
// module chunks = 1